// This checks whether a value is a plain object
const isPlainObject = (value) => {

    // Return whether the value is a real object and not an array
    return value !== null && typeof value === "object" && !Array.isArray(value);

};



// This compares two values deeply and optionally ignores selected object keys
export const deepEqual = (firstValue, secondValue, ignoredKeys = []) => {

    // Return true if both values are exactly the same
    if (firstValue === secondValue) return true;

    // Handle arrays
    if (Array.isArray(firstValue) || Array.isArray(secondValue)) {

        // Return false if only one value is an array
        if (!Array.isArray(firstValue) || !Array.isArray(secondValue)) return false;

        // Return false if the arrays are different lengths
        if (firstValue.length !== secondValue.length) return false;

        // Return whether every array item matches by index
        return firstValue.every((item, index) => deepEqual(item, secondValue[index], ignoredKeys));

    }

    // Handle plain objects
    if (isPlainObject(firstValue) && isPlainObject(secondValue)) {

        // Get the first object keys, excluding ignored keys
        const firstKeys = Object.keys(firstValue).filter((key) => !ignoredKeys.includes(key));

        // Get the second object keys, excluding ignored keys
        const secondKeys = Object.keys(secondValue).filter((key) => !ignoredKeys.includes(key));

        // Return false if the objects have different key counts
        if (firstKeys.length !== secondKeys.length) return false;

        // Return whether every object key exists and deeply matches
        return firstKeys.every((key) => {

            // Return false if the second object does not have this key
            if (!Object.prototype.hasOwnProperty.call(secondValue, key)) return false;

            // Return whether the values deeply match
            return deepEqual(firstValue[key], secondValue[key], ignoredKeys);

        });

    }

    // Return false for different primitive values or mismatched structures
    return false;

};



// Helper that converts any value into a deterministic (stable) string
export const stableStringify = (val) => {

  // Comparator to sort object keys alphabetically so output is consistent
  const sort = (a, b) => a.localeCompare(b);

  // Recursive walker that stringifies with stable ordering
  const walk = (x) =>

    // If it's an array, stringify each item in order and wrap with brackets
    Array.isArray(x)
      ? `[${x.map(walk).join(",")}]`

      // If it's a non-null object, sort keys and stringify key/value pairs
      : (x && typeof x === "object")
        ? `{${Object.keys(x).sort(sort).map(
            // For each key, stringify the key and the recursively-walked value
            (k) => `${JSON.stringify(k)}:${walk(x[k])}`
          // Join all key/value pairs with commas to form the object body
          ).join(",")}}`

        // For primitives (string/number/boolean/null/undefined), delegate to JSON.stringify
        : JSON.stringify(x);

  // Return the final stable string for the provided input value
  return walk(val);

};



// This checks whether a value looks like an email address
export const IsEmailValue = (value) => {

    // Ensure we only work with strings
    if (typeof value !== "string") {

        // Non-strings cannot be emails
        return false;

    }

    // Basic email pattern for UI preview purposes
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

}; 